__turbopack_context__.v({
  "bar": "Header-module-scss-module__SLxbNa__bar",
  "bar--clicked": "Header-module-scss-module__SLxbNa__bar--clicked",
  "desktopCta": "Header-module-scss-module__SLxbNa__desktopCta",
  "hamburgerButton": "Header-module-scss-module__SLxbNa__hamburgerButton",
  "hamburgerIcon": "Header-module-scss-module__SLxbNa__hamburgerIcon",
  "hamburgerText": "Header-module-scss-module__SLxbNa__hamburgerText",
  "header": "Header-module-scss-module__SLxbNa__header",
  "headerLogo": "Header-module-scss-module__SLxbNa__headerLogo",
  "headerWrapper": "Header-module-scss-module__SLxbNa__headerWrapper",
  "megaMenu": "Header-module-scss-module__SLxbNa__megaMenu",
  "megaMenu--opened": "Header-module-scss-module__SLxbNa__megaMenu--opened",
  "navContent": "Header-module-scss-module__SLxbNa__navContent",
  "navItem": "Header-module-scss-module__SLxbNa__navItem",
  "navItem--activeMenu": "Header-module-scss-module__SLxbNa__navItem--activeMenu",
  "navList": "Header-module-scss-module__SLxbNa__navList",
});
